export const VISITATION_TYPE_TEMPLATE = {
  INITIAL_EVALUATION: 1,
  IMPLANTATION: 2
};
